import '.ag{position:relative;}.ssr-plugin'
import '.ie{width:64px;}.ssr-plugin'
import '.if{height:64px;}.ssr-plugin'
import '.ai{flex-shrink:0;}.ssr-plugin'
import '.c0{position:absolute;}.ssr-plugin'
import '.ig{bottom:-4px;}.ssr-plugin'
import '.hc{right:-4px;}.ssr-plugin'
import '.fq{border-radius:50%;}.ssr-plugin'
import '.ih{border:2px solid var(--palette-white);}.ssr-plugin'
import '.at{overflow:hidden;}.ssr-plugin'
import '.ii{width:32px;}.ssr-plugin'
import '.ij{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'

type ConversationAvatarProps = {
  initiativeImage?: string
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  return (
    <div className="ag ie if ai"
    >
      {initiativeImage ? (
        <Image
          src={initiativeImage}
          resizeWidth={128}
          alt="initiative"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="c0 ig hc fq ih at ii ij"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
